// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1AgiX","errorLogs":"styles_errorLogs__1aBIV"};